export function OcultarCpfRegex(cpf: string): string {
  const cpfNumerico = cpf.replace(/\D/g, '');
  if (cpfNumerico.length !== 11) {
      return '';
  }
  const cpfMascarado = cpfNumerico.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '***.***.$3-$4');

  return cpfMascarado;
}
